/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_MatchesInputs */



/**
* | output |
* | --- |
* | "Nothing matches your search." |
*
* @param {Team_Manager_No_MatchesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_matches = /** @type {((inputs?: Team_Manager_No_MatchesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_MatchesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun résultat.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Treffer.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun risultato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ничего не найдено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay resultados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有匹配的结果。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一致する項目はありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपकी खोज से कुछ मेल नहीं खाता।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem resultados.")
	return /** @type {LocalizedString} */ ("Nothing matches your search.")
});